import { render } from "./PhotoWork.vue?vue&type=template&id=d8b1a49c&scoped=true"
import script from "./PhotoWork.vue?vue&type=script&lang=ts"
export * from "./PhotoWork.vue?vue&type=script&lang=ts"

import "./PhotoWork.vue?vue&type=style&index=0&id=d8b1a49c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d8b1a49c"

export default script